import { useEffect, useRef } from "react";
import { gsap } from "gsap";

export default function CTA() {
  const root = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!root.current) return;
    const ctx = gsap.context(() => {
      gsap.from(".cta-word", {
        yPercent: 110,
        opacity: 0,
        duration: 1,
        stagger: 0.08,
        ease: "power3.out",
        scrollTrigger: { trigger: root.current, start: "top 75%" },
      });
      gsap.from(".cta-thumb", {
        y: 50,
        opacity: 0,
        duration: 1,
        stagger: 0.12,
        ease: "power3.out",
        scrollTrigger: { trigger: ".cta-row", start: "top 85%" },
      });
    }, root);
    return () => ctx.revert();
  }, []);

  const line1 = "Wear what".split(" ");
  const line2 = "lasts.".split(" ");

  const thumbs = [
    "https://readdy.ai/api/search-image?query=minimalist%20cream%20linen%20shirt%20floating%20product%20photography%20on%20pure%20white%20background%2C%20sustainable%20fashion%20cutout%20editorial%2C%20soft%20natural%20light%2C%20warm%20earth%20tone%2C%20clean%20composition&width=400&height=500&seq=verdant-cta-1&orientation=portrait",
    "https://readdy.ai/api/search-image?query=oversized%20oat%20colored%20knit%20sweater%20floating%20product%20photography%20on%20pure%20white%20background%2C%20sustainable%20fashion%20cutout%20editorial%2C%20soft%20natural%20light%2C%20warm%20earth%20tone%2C%20clean%20composition&width=400&height=500&seq=verdant-cta-2&orientation=portrait",
    "https://readdy.ai/api/search-image?query=rust%20terracotta%20colored%20silk%20dress%20floating%20product%20photography%20on%20pure%20white%20background%2C%20sustainable%20fashion%20cutout%20editorial%2C%20soft%20natural%20light%2C%20warm%20earth%20tone%2C%20clean%20composition&width=400&height=500&seq=verdant-cta-3&orientation=portrait",
    "https://readdy.ai/api/search-image?query=natural%20undyed%20wool%20wide%20leg%20trousers%20floating%20product%20photography%20on%20pure%20white%20background%2C%20sustainable%20fashion%20cutout%20editorial%2C%20soft%20natural%20light%2C%20warm%20earth%20tone%2C%20clean%20composition&width=400&height=500&seq=verdant-cta-4&orientation=portrait",
    "https://readdy.ai/api/search-image?query=olive%20green%20linen%20overshirt%20coat%20floating%20product%20photography%20on%20pure%20white%20background%2C%20sustainable%20fashion%20cutout%20editorial%2C%20soft%20natural%20light%2C%20warm%20earth%20tone%2C%20clean%20composition&width=400&height=500&seq=verdant-cta-5&orientation=portrait",
  ];

  return (
    <section ref={root} className="bg-bone py-16 md:py-20 px-6 md:px-10 overflow-hidden">
      <div className="text-center max-w-4xl mx-auto">
        <h2 className="font-display tracking-tightest leading-[0.92] text-ink text-7xl md:text-9xl lg:text-[180px] font-light">
          <span className="block overflow-hidden">
            {line1.map((w, i) => (
              <span key={i} className="inline-block overflow-hidden">
                <span className="cta-word inline-block mr-4">{w}</span>
              </span>
            ))}
          </span>
          <span className="block overflow-hidden font-display text-rust">
            {line2.map((w, i) => (
              <span key={i} className="inline-block overflow-hidden">
                <span className="cta-word inline-block">{w}</span>
              </span>
            ))}
          </span>
        </h2>

        <p className="mt-6 text-ink/70 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
          A wardrobe of fewer pieces, each made to outlive trends, restorations included for a decade.
        </p>

        <div className="mt-8">
          <a
            href="/shop"
            className="inline-flex items-center gap-3 bg-forest text-bone px-8 py-4 rounded-full text-sm font-medium tracking-wide uppercase hover:bg-ink transition-colors cursor-pointer whitespace-nowrap"
          >
            Shop the collection
            <i className="ri-arrow-right-up-line text-base"></i>
          </a>
        </div>
      </div>

      <div className="cta-row mt-12 flex items-end justify-center gap-3 md:gap-5">
        {thumbs.map((src, i) => (
          <div
            key={i}
            className={`cta-thumb relative shrink-0 ${
              i === 0 ? "w-24 md:w-40 aspect-[3/4]" : ""
            } ${i === 1 ? "w-28 md:w-48 aspect-[3/4] -translate-y-6" : ""} ${
              i === 2 ? "w-32 md:w-56 aspect-[3/4] -translate-y-12" : ""
            } ${i === 3 ? "w-28 md:w-48 aspect-[3/4] -translate-y-6" : ""} ${
              i === 4 ? "w-24 md:w-40 aspect-[3/4]" : ""
            }`}
          >
            <img src={src} alt="" className="w-full h-full object-contain object-bottom" />
          </div>
        ))}
      </div>
    </section>
  );
}